import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { isBackofficeUser } from 'helpers/userRoles';
// import AllClients from '../AllClients';
import AllPortfolios from '../AllPortfolios';
import BrokerClients from '../BrokerClients';
import { useFeature } from '@growthbook/growthbook-react';
import AllClientsAndPortfolios from '../AllClientsAndPortfolios';

const Clients = () => {
  const { userRoles } = useAuth();
  const PORTFOLIO_LIST = useFeature('backoffice-portfolios-list').on;

  if (isBackofficeUser(userRoles)) {
    if (PORTFOLIO_LIST) return <AllPortfolios />;
    // return <AllClients />;
    return <AllClientsAndPortfolios />;
  }

  return <BrokerClients />;
};

export default Clients;
